import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ContractVehicles.css';

const contractTabs = [
  {
    name: 'Overview',
    title: 'Working with us',
  },
  {
    name: 'GSA MAS',
    title: 'GSA MAS',
    number: 'GS-00F-184GA',
    type: 'Small Business',
    details: '54151S, 541611, 541214, 541219, 512110, 522310, 54151HACS, OLM',
    description: 'The GSA Schedule, also known as Federal Supply Schedule (FSS), and Multiple Award Schedule (MAS), is a long-term governmentwide contract that allows commercial companies to do business with the government by providing access to millions of commercial products and services at fair and reasonable prices. MAS makes buying easy and efficient, helping both government and industry save time and money.'
  },
  {
    name: 'NITAAC CIO-SP3 8(a)',
    title: 'NITAAC CIO-SP3 8(a)',
    number: '75N8119D00056',
    type: '8(a)',
    details: 'All 10 Tracks',
    description: 'The NITAAC CIO-SP3 8(a) is a government-wide, indefinite-delivery indefinite-quantity (IDIQ) contract managed by the National Institutes of Health Information Technology Acquisition and Assessment Center (NITAAC) designed to provide federal agencies with streamlined access to a wide range of IT services and solutions. Specifically tailored for small, disadvantaged businesses certified under the SBA\'s 8(a) program, CIO-SP3 8(a) enables agencies to meet their small business and diversity goals while supporting projects in areas such as system design, software development, cybersecurity, and health IT. It offers a flexible, competitive, and efficient procurement pathway, ensuring agencies can quickly and confidently engage qualified 8(a) vendors for their IT needs.'
  },
  {
    name: 'NITAAC CIO-SP3 SB',
    title: 'NITAAC CIO-SP3 SB',
    number: '75N98120D00121',
    type: 'Small Business',
    details: 'All 10 Tracks',
    description: 'The NITAAC CIO-SP3 Small Business (SB) is a government-wide, indefinite-delivery indefinite-quantity (IDIQ) contract vehicle managed by the National Institutes of Health Information Technology Acquisition and Assessment Center (NITAAC). It is specifically designed to provide federal agencies with easy access to a broad range of information technology (IT) solutions and services from small businesses. CIO-SP3 SB supports agencies in fulfilling their small business contracting goals by offering a pool of pre-qualified small business vendors capable of delivering expertise in ten IT task areas, including systems design, software engineering, cybersecurity, and health IT. This contract streamlines the procurement process, reduces administrative burden, and promotes competition among qualified small businesses for federal IT projects.'
  },
  {
    name: 'GSA 8(a) STARS III',
    title: 'GSA 8(a) STARS III',
    number: '47QTCB21D0185',
    type: '8(a)',
    details: 'All areas + Leading Edge Technologies',
    description: 'GSA 8(a) STARS III is a multiple-award, indefinite-delivery indefinite-quantity (IDIQ) government-wide acquisition contract (GWAC) managed by the U.S. General Services Administration (GSA). It is designed to help federal agencies access a diverse pool of highly qualified, SBA-certified 8(a) small, disadvantaged businesses for customized information technology (IT) services and solutions. The contract supports a wide array of IT disciplines, including emerging technologies, cybersecurity, cloud services, and software development, while also enabling agencies to meet their small business and socioeconomic contracting goals. With its streamlined acquisition process and flexibility to address complex IT requirements, GSA 8(a) STARS III offers federal buyers an efficient and competitive pathway to procure innovative IT services from trusted 8(a) vendors.'
  },
  {
    name: 'GSA OASIS SB',
    title: 'GSA OASIS SB',
    number: '47QRCA25DSD08',
    type: 'Small Business',
    details: 'T&E, M&A',
    description: 'GSA OASIS Small Business (SB) is a multiple-award, indefinite-delivery indefinite-quantity (IDIQ) contract vehicle managed by the U.S. General Services Administration (GSA), designed to provide federal agencies with flexible and comprehensive access to a wide range of professional services from small business contractors. Covering areas such as management consulting, logistics, engineering, scientific, financial, and program management services, OASIS SB helps agencies efficiently acquire complex, integrated solutions while supporting their small business contracting objectives. The contract streamlines the procurement process, promotes competition among qualified small business vendors, and enables agencies to fulfill requirements for mission-critical professional services across diverse fields.'
  },
  {
    name: 'FAA eFAST',
    title: 'FAA eFAST',
    number: 'DTFAWA13A-00181',
    type: '8(a) and Small Business',
    details: 'All Task Areas',
    description: 'FAA eFAST (Electronic Federal Aviation Administration Accelerated and Simplified Tasks) is a multi-year Master Ordering Agreement (MOA) program managed by the Federal Aviation Administration (FAA) to provide federal agencies with streamlined, flexible access to a broad array of professional and support services. Designed specifically for small businesses, eFAST covers service areas such as engineering, computer/information systems development, business administration, and management consulting, among others. The program simplifies and accelerates the procurement process while enabling federal agencies to meet small business and socioeconomic contracting goals by engaging a diverse pool of qualified vendors through pre-vetted, competitively awarded agreements.'
  },
  {
    name: 'Seaport-NXG',
    title: 'Seaport-NXG',
    number: 'N0017819D7808',
    type: '8(a) and Small Business',
    details: 'All Task Areas',
    description: 'SeaPort-NxG is the U.S. Navy\'s next-generation, multiple-award, indefinite-delivery indefinite-quantity (IDIQ) contract vehicle designed to provide the Navy and other Department of Defense (DoD) agencies with a streamlined way to acquire a comprehensive range of engineering, technical, program management, and professional support services. Managed by the Naval Sea Systems Command (NAVSEA), SeaPort-NxG supports requirements across 23 functional areas, including systems engineering, software development, cybersecurity, and logistics. The contract promotes competition among a wide pool of large and small businesses, making it easy for government buyers to procure high-quality support while meeting their small business and socioeconomic objectives efficiently.'
  },
  {
    name: 'SBA Approved ANC JV – InaHarbor, LLC',
    title: 'SBA Approved ANC JV – InaHarbor, LLC',
    number: '',
    type: 'ANC (8a)',
    details: 'Sole Source Eligible - up to $25M – Fed Civ and up to $100M – DoD Agencies',
    description: 'SBA Approved ANC JV – InaHarbor, LLC is a joint venture formed under U.S. Small Business Administration guidelines for Alaska Native Corporations (ANCs), giving it access to unique federal contracting advantages like sole-source and competitive set-aside awards under the 8(a) Business Development Program. As an ANC-owned small business with multiple certifications—including SBA 8(a), Minority Owned Business, and Indian Economic Enterprise—InaHarbor helps federal agencies meet their small business and socioeconomic contracting goals with professional, technical, and management services. Its proven track record includes delivering IT program management services and other major contracts for the Department of State and the Department of the Army, demonstrating its capacity to provide high-quality solutions for both civilian and defense agencies.'
  },
];

export default function ContractVehicles() {
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    document.title = 'Contract Vehicles';
    window.scrollTo(0, 0);
  }, []);

  const renderContent = () => {
    if (selected === 0) {
      return (
        <>
          <p className="contract-overview-text">
            Inalab's services can be easily retained by using a variety of contract vehicles, including General Services Administration (GSA) schedules, Government Wide Acquisition Contracts (GWACs), Indefinite Delivery/Indefinite Quantity (IDIQ) contracts, and Blanket Purchase Agreements (BPAs). These flexible options are designed to provide Federal and State Government agencies with streamlined access to our high-quality, cost-effective solutions.
          </p>
          <p className="contract-overview-text">
            Key advantages include:
          </p>
          <ul className="contract-overview-list">
            <li>Streamlined request for quote and award processes</li>
            <li>A broad range of services</li>
            <li>Pre-negotiated services and rates</li>
            <li>Rapid closure on task or delivery orders</li>
            <li>Minimal administration burden</li>
          </ul>
          <p className="contract-overview-text">
            For more information about our contract vehicles, please <Link to="/contact" className="contract-contact-link">contact us</Link>.
          </p>
        </>
      );
    }
    const tab = contractTabs[selected];
    return (
      <div role="tabpanel" id={`panel-${tab.name}`} aria-labelledby={`tab-${tab.name}`} className="contract-details-text">
        <p className="contract-details-item">{tab.description}</p>
        {tab.name !== 'SBA Approved ANC JV – InaHarbor, LLC' && (
          <p className="contract-details-item"><strong className="contract-details-label">Contract Number:</strong> {tab.number || '—'}</p>
        )}
        <p className="contract-details-item"><strong className="contract-details-label">Contract Type:</strong> {tab.type || '—'}</p>
        <p className="contract-details-item"><strong className="contract-details-label">Contract Details:</strong> {tab.details || '—'}</p>
      </div>
    );
  };

  return (
    <>
      <div className="page-banner" style={{ backgroundImage: 'url(/contract_banner.png)' }}>
        <h1 className="page-banner-title" id="contract-vehicles-heading">
          Contract Vehicles
        </h1>
      </div>
      <main className="contract-page-wrapper" aria-labelledby="contract-vehicles-heading">
        {/* Desktop Tabs */}
        <div className="contract-tabs-container contract-tabs-desktop" role="tablist" aria-orientation="vertical">
          {contractTabs.map((tab, idx) => (
            <button
              key={tab.name}
              onClick={() => setSelected(idx)}
              className={`contract-tab-button ${selected === idx ? 'contract-tab-button-selected' : ''}`}
              role="tab"
              aria-selected={selected === idx}
              aria-controls={`panel-${tab.name}`}
              id={`tab-${tab.name}`}
            >
              <span className="contract-tab-button-text">{tab.name}</span>
            </button>
          ))}
        </div>
        {/* Mobile Dropdown */}
        <div className="contract-tabs-mobile">
          <select
            className="contract-tabs-dropdown"
            value={selected}
            onChange={e => setSelected(Number(e.target.value))}
            aria-label="Select contract vehicle"
          >
            {contractTabs.map((tab, idx) => (
              <option key={tab.name} value={idx}>{tab.name}</option>
            ))}
          </select>
        </div>
        <div className="contract-content-area">
          <h2 className="contract-content-heading">{contractTabs[selected].title}</h2>
          {renderContent()}
        </div>
      </main>
    </>
  );
} 